import { IRutinInfo } from '../../../../../Types/RutinInfoType';
import { rutinInfos } from '../RutinInfo';

const EKRutinMeny: IRutinInfo[] = [
  rutinInfos.rtnVerifikation,
  rutinInfos.rtnBudgetVerifikation,
  rutinInfos.rtnEkonomiskAnalys,
  rutinInfos.rtnSpecEkoRapport,
  rutinInfos.rtnEKRapportpaket,
  rutinInfos.rtnKonteringar,
  rutinInfos.rtnFakturahandelser,
  rutinInfos.rtnPersonalregister,
  rutinInfos.rtnAutomatkontering,
  rutinInfos.rtnOmfordelning,
  rutinInfos.rtnGava,
  rutinInfos.rtnWebBokforder,
  rutinInfos.rtnAnalysutdelning,
  rutinInfos.rtnWebBudgetAskandemallar,
];

export default EKRutinMeny;
